import { Analysis } from 'common-spectrum';
import {
  xMean,
  xMinMaxValues,
  xStandardDeviation,
} from 'ml-spectra-processing/x';
import { pelletHardnessParseHitec } from 'physical-chemistry-parser';

export function fromHitec(dt0, res) {
  let analysis = new Analysis();
  const parsed = pelletHardnessParseHitec(dt0, res);
  let meta = {};
  for (let key in parsed.meta) {
    meta = { ...meta, ...parsed.meta[key] };
  }

  let iph = parsed.variables.y.data;
  iph.sort((a, b) => b - a);
  let top10 = iph.slice(0, iph.length / 10);
  const { min, max } = xMinMaxValues(iph);
  const mean = xMean(iph);
  const sd = xStandardDeviation(iph, { mean });
  const cheminfo = {
    meta: {
      average50: {
        value: mean,
        units: 'cN',
      },
      sd: {
        value: sd,
        units: 'cN',
      },
      min: {
        value: min,
        units: 'cN',
      },
      max: {
        value: max,
        units: 'cN',
      },
      averageHardest10: {
        value: xMean(top10),
        units: 'cN',
      },
      method: meta.QualityName,
    },
  };

  meta.cheminfo = cheminfo;

  analysis.pushSpectrum(
    {
      x: parsed.variables.x,
      y: parsed.variables.y,
    },
    {
      dataType: 'Individual pellet hardness',
      title: meta.Meta,
      meta,
    },
  );

  return analysis;
}
